import React, { useState, useEffect } from 'react';
import PDFViewer from 'pdf-viewer-reactjs'
import PdfViewerPassword from './PdfViewerPassword';
import $ from 'jquery';
import styles from '../../styles/pdfViewer.module.css';

export default function PdfViewer(props) {
    const [pdfBase64, setPdfBase64] = React.useState(props.pdfData);
    const [isEncrypted, setIsEncrypted] = useState(false);
    const [password, setPassword] = React.useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [canLoadPDF, setCanLoadPDF] = useState(null);
    const [isPasswordException, setIsPasswordException] = useState(false);

    useEffect(() => {
        resizePdfBar();

        window.addEventListener('orientationchange', updateOrientation);

        loadPage();

        console.warn = (...args) => {
            const nameException = args[1]?.name;

            if (nameException == 'PasswordException') {
                setIsPasswordException(true);
                setPassword(null);
            }
        };
    }, [])

    useEffect(() => {
        setShowPassword(isEncrypted && !canLoadPDF);
    }, [isEncrypted, canLoadPDF]);

    useEffect(() => {
        if (password !== null) {
            setCanLoadPDF(password !== '');
        }
    }, [password]);

    useEffect(() => {
        if (isPasswordException) {
            setShowPassword(true);
            setCanLoadPDF(false);
        }
    }, [isPasswordException]);

    const loadPage = () => {
        const pdfData = atob(pdfBase64);
        const isPdfEncrypted = pdfData.substring(pdfData.lastIndexOf("<<"), pdfData.lastIndexOf(">>")).includes("/Encrypt");

        setIsEncrypted(isPdfEncrypted);
        setCanLoadPDF(!isPdfEncrypted);

        resizePdfBar();

        window.addEventListener('orientationchange', updateOrientation);
    }

    const handlePassword = (password) => {
        setIsPasswordException(false);
        setPassword(password);
    }

    const updateOrientation = () => {
        resizePdfBar();
    }

    return (
        <div className={styles.rootPdf}>
            {showPassword && <PdfViewerPassword handlePassword={handlePassword} isErrorException={isPasswordException} />}

            {canLoadPDF && !showPassword && <PDFViewer
                hideRotation={true}
                minScale={0.1}
                scaleStep={0.1}
                scale={1.5}
                password={password}
                document={{
                    base64: pdfBase64
                }}
            />}
        </div>
    );
}

function resizePdfBar() {
    setTimeout(function () {
        const height = window.innerHeight;
        const header = $('.MuiPaper-root.MuiAppBar-root.MuiAppBar-positionFixed.MuiAppBar-colorPrimary.mui-fixed.MuiPaper-elevation4').height();
        const pdfBar = $('.columns.is-gapless.box.is-mobile.has-text-white.has-background-black.has-margin-top-15.has-margin-bottom-15').height();
        const offSet = 95;

        const customHeight = height - header - pdfBar - offSet;

        $('canvas').parent().css('height', `${customHeight}px`);
    }, 1000);
}